// Canonical modal styling. Every modal (and confirm dialog) should use these
// so they look identical everywhere — same card, same button size/radius/font.
//
// Buttons:
//  - modalPrimaryBtn    : the confirming action (Apply / Save / Generate / Close / OK…)
//  - modalSecondaryBtn  : Cancel / Back — solid light grey, NOT a white/outline
//    button, and no hover state (flat, matching the rest of the app)
//  - modalDangerBtn     : a destructive confirm (Delete / Yes)
// In a 2-button row each button also gets `flex: 1`; a lone full-width button
// gets `width: '100%'`. MODAL_BTN_ROW is the flex wrapper.
//
// Card / text (used by the plain confirm dialogs):
//  - modalCard, modalTitle, modalBody

const BTN_FONT_SIZE = 14;
const BTN_LINE_HEIGHT = 1.2;
const BTN_PADDING = 11;

const base = {
  padding: `${BTN_PADDING}px`,
  borderRadius: 8,
  border: 'none',
  cursor: 'pointer',
  fontSize: BTN_FONT_SIZE,
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 500,
  lineHeight: BTN_LINE_HEIGHT,
};

// The exact rendered height of the buttons above (one line of text + top
// and bottom padding, no border) — for other controls that must match it
// exactly, e.g. the option buttons in the Settings modal.
export const MODAL_BTN_HEIGHT = BTN_FONT_SIZE * BTN_LINE_HEIGHT + 2 * BTN_PADDING;

export const modalPrimaryBtn = { ...base, background: '#1a1a1a', color: '#fff' };
export const modalSecondaryBtn = { ...base, background: '#ececec', color: '#1a1a1a' };
export const modalDangerBtn = { ...base, background: '#ef4444', color: '#fff' };

export const MODAL_BTN_ROW = { display: 'flex', gap: 10, marginTop: 20 };

export const modalCard = {
  backgroundColor: '#fff',
  borderRadius: 12,
  padding: '24px 28px 20px',
  maxWidth: 380,
  width: '90%',
  pointerEvents: 'auto',
  textAlign: 'left',
};

export const modalTitle = {
  fontSize: 15,
  fontWeight: 600,
  color: '#1a1a1a',
  fontFamily: 'Inter, Arial, sans-serif',
  margin: '0 0 8px',
};

export const modalBody = {
  fontSize: 13,
  color: '#666',
  fontFamily: 'Inter, Arial, sans-serif',
  margin: '0 0 20px',
};
